import angular from 'angular';
import config from './settings.config';

import {StepFirst} from './step-1/step-1.component';
import {StepSecond} from './step-2/step-2.component';
import {StepThird} from './step-3/step-3.component';
import {StepFourth} from './step-4/step-4.component';
import {StepFifth} from './step-5/step-5.component';
import {StepSixth} from './step-6/step-6.component';
import {Summary} from './summary/summary.component';

/**
 * Controllers to step 1
 */
import AddClassRoomController from './add-class-room/add-class-room.controller';
import AddEmployeeController from './add-employee/add-employee.controller';
import EditEmployeeController from './edit-employee/edit-employee.controller';

/**
 * Controllers to step 2
 */
import AddWorkPeriodController from './add-work-period/add-work-period.controller';
import AddWorkDayController from './add-work-day/add-work-day.controller';
import EditWorkDayController from './edit-work-day/edit-work-day.controller';
import EditWorkPeriodController from './edit-work-period/edit-work-period.controller';
import ChooseActionController from './choose-action/choose-action.controller';
import CollisionsWorkPeriodController from './collisions-work-period/collisions-work-period.controller';

/**
 * Controllers to step 3
 */
import ListGroupController from './list-group/list-group.controller';
import AssignStudentController from './assign-student/assign-student.controller';
import AddStudentsController from './add-students/add-students.controller';

/**
 * Controllers to step 4
 */
import AddSchedulePointController from './add-schedule-point/add-schedule-point.controller';

/**
 * Controllers to step 6
 */
import AddActivityController from './add-activity/add-activity.controller';
import EditActivityController from './edit-activity/edit-activity.controller';

/**
 * Controllers to summary
 */
import ListEmployeeController from './list-employee/list-employee.controller';
import ListWorkDaysController from './list-work-days/list-work-days.controller';
import ListStudentController from './list-student/list-student.controller';
import ListSchedulePointsController from './list-schedule-points/list-schedule-points.controller';
import ShowTargetsController from './show-targets/show-targets.controller';
import ListActivitiesController from './list-activities/list-activities.controller';

import './settings.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.settings', [])
  .component('stepFirstComponent', StepFirst)
  .component('stepSecondComponent', StepSecond)
  .component('stepThirdComponent', StepThird)
  .component('stepFourthComponent', StepFourth)
  .component('stepFifthComponent', StepFifth)
  .component('stepSixthComponent', StepSixth)
  .component('summaryComponent', Summary)
  .controller('AddClassRoomController', AddClassRoomController)
  .controller('AddEmployeeController', AddEmployeeController)
  .controller('EditEmployeeController', EditEmployeeController)
  .controller('AddWorkPeriodController', AddWorkPeriodController)
  .controller('AddWorkDayController', AddWorkDayController)
  .controller('EditWorkDayController', EditWorkDayController)
  .controller('EditWorkPeriodController', EditWorkPeriodController)
  .controller('ChooseActionController', ChooseActionController)
  .controller('CollisionsWorkPeriodController', CollisionsWorkPeriodController)
  .controller('ListGroupController', ListGroupController)
  .controller('AssignStudentController', AssignStudentController)
  .controller('AddStudentsController', AddStudentsController)
  .controller('AddSchedulePointController', AddSchedulePointController)
  .controller('AddActivityController', AddActivityController)
  .controller('EditActivityController', EditActivityController)
  .controller('ListEmployeeController', ListEmployeeController)
  .controller('ListWorkDaysController', ListWorkDaysController)
  .controller('ListStudentController', ListStudentController)
  .controller('ListSchedulePointsController', ListSchedulePointsController)
  .controller('ShowTargetsController', ShowTargetsController)
  .controller('ListActivitiesController', ListActivitiesController)
  .config(config)
  .name;
